
export const generatePeriods = (calendar) => {
    if (!calendar) return [];

    const {
        granularity,
        forecast_start,
        actual_start,
        actual_period_count = 0,
        forecast_period_count = 0,
    } = calendar;

    const totalPeriods = (actual_period_count || 0) + (forecast_period_count || 0);
    if (totalPeriods <= 0) return [];

    const periodList = [];

    const addUnits = (baseDate, units) => {
        const d = new Date(baseDate);
        if (granularity === 'week') {
            d.setUTCDate(d.getUTCDate() + (units * 7));
        } else if (granularity === 'month') {
            d.setUTCMonth(d.getUTCMonth() + units);
        } else { // 'day' or fallback
            d.setUTCDate(d.getUTCDate() + units);
        }
        return d;
    };

    if (forecast_start) {
        // First visible period is forecast_start minus actual_period_count units
        const forecastStart = new Date(forecast_start + 'T00:00:00Z');
        const firstVisible = addUnits(forecastStart, -actual_period_count);
        for (let i = 0; i < totalPeriods; i++) {
            const periodDate = addUnits(firstVisible, i);
            periodList.push(periodDate.toISOString().split('T')[0]);
        }
        return periodList;
    }

    // Legacy fallback: start from actual_start and show totalPeriods forward
    if (!actual_start) return [];
    const legacyStart = new Date(actual_start + 'T00:00:00Z');
    for (let i = 0; i < totalPeriods; i++) {
        const periodDate = addUnits(legacyStart, i);
        periodList.push(periodDate.toISOString().split('T')[0]);
    }
    return periodList;
};

/**
 * Check if a period is an actual (vs forecast)
 * @param {number} periodIndex - 0-based period index
 * @param {number} actualPeriodCount - Number of actual periods
 * @returns {boolean} True if actual period
 */
export const isActualPeriod = (periodIndex, actualPeriodCount) => {
    return periodIndex < actualPeriodCount;
};

/**
 * Get visible period window
 * @param {string[]} allPeriods - All period dates
 * @param {number} offset - Starting offset
 * @param {number} pageSize - Number of periods per page
 * @returns {Object} Object with visiblePeriods, start, end, canGoPrev, canGoNext
 */
export const getPeriodWindow = (allPeriods, offset, pageSize) => {
    const totalPeriods = allPeriods.length;
    const start = offset;
    const end = Math.min(offset + pageSize, totalPeriods);
    const visiblePeriods = allPeriods.slice(start, end);
    
    return {
        visiblePeriods,
        start,
        end,
        canGoPrev: offset > 0,
        canGoNext: end < totalPeriods,
        totalPeriods
    };
};

